import CampaignTemplateBasicDetailsSlide from "./CampaignTemplateBasicDetailsSlide";

export default CampaignTemplateBasicDetailsSlide;
